var map = {
	"./GMD/GMD.module": [
		"./src/app/GMD/GMD.module.ts",
		"default~GMD-GMD-module~admin-admin-module~dashboard-sorting-dashboard-sorting-module",
		"GMD-GMD-module"
	],
	"./admin/admin.module": [
		"./src/app/admin/admin.module.ts",
		"default~GMD-GMD-module~admin-admin-module~dashboard-sorting-dashboard-sorting-module",
		"admin-admin-module"
	],
	"./dashboard-sorting/dashboard-sorting.module": [
		"./src/app/dashboard-sorting/dashboard-sorting.module.ts",
		"default~GMD-GMD-module~admin-admin-module~dashboard-sorting-dashboard-sorting-module",
		"dashboard-sorting-dashboard-sorting-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;